/* component-cart-platmart.js
 *
 * Hydrates two Platmart-driven slots in the cart drawer:
 *
 *   1. Cart line items — <span data-platmart-cart-line data-product-handle="X">
 *      gets filled with a small swatch image + the color name (e.g.
 *      "[swatch] Floral"). Sits between the line title and the size row.
 *
 *   2. "You may also like" cards — <div data-platmart-cart-color
 *      data-product-handle="X"> gets a single small swatch dot for the
 *      current color of that recommended product.
 *
 * Also wires the prev/next chevron buttons on the recommendations carousel:
 *   - Both buttons are hidden by default.
 *   - The right (next) button shows immediately if the row can scroll right.
 *   - The left (prev) button only appears once the user has scrolled past
 *     the start, and disappears when scrolled back to the beginning. This
 *     matches the EU site exactly.
 */
(function () {
  if (typeof window === 'undefined') return;

  function getData() { return window.PLATMART_SWATCHES || null; }

  function lookupMember(handle) {
    var data = getData();
    if (!data || !data.h || !data.g) return null;
    var key = data.h[handle];
    if (!key) return null;
    var group = data.g[key];
    if (!group || !group.m) return null;
    for (var i = 0; i < group.m.length; i++) {
      if (group.m[i].h === handle) return group.m[i];
    }
    return null;
  }

  function buildSwatchDot(member, size) {
    var dot = document.createElement('span');
    dot.className = 'cart-platmart-swatch__dot';
    dot.style.width = size;
    dot.style.height = size;
    if (member.t === 'custom_image' && member.img) {
      dot.style.backgroundImage = 'url("' + member.img + '")';
      dot.style.backgroundSize = 'cover';
      dot.style.backgroundPosition = 'center';
    } else if (member.t === 'one_color' && member.c1) {
      if (member.c2) {
        dot.style.background = 'linear-gradient(-45deg,' + member.c1 + ' 0%,' + member.c1 + ' 50%,' + member.c2 + ' 50%,' + member.c2 + ' 100%)';
      } else {
        dot.style.backgroundColor = member.c1;
      }
      if ((member.c1 || '').toLowerCase() === '#ffffff' || (member.c1 || '').toLowerCase() === '#fff') {
        dot.style.borderColor = '#d1d1d1';
      }
    } else if (member.t === 'product_image' && member.img) {
      dot.style.backgroundImage = 'url("' + member.img + '")';
      dot.style.backgroundSize = 'cover';
      dot.style.backgroundPosition = 'center';
    } else {
      dot.style.backgroundColor = '#EAEAEA';
    }
    return dot;
  }

  function hydrateLineItem(el) {
    if (!el || el.getAttribute('data-platmart-done') === '1') return;
    var handle = el.getAttribute('data-product-handle');
    if (!handle) return;
    var member = lookupMember(handle);
    if (!member) {
      el.setAttribute('data-platmart-done', '1');
      return;
    }
    el.innerHTML = '';
    el.appendChild(buildSwatchDot(member, '0.75rem'));
    var label = document.createElement('span');
    label.className = 'cart-platmart-swatch__label';
    label.textContent = member.n || '';
    el.appendChild(label);
    el.setAttribute('data-platmart-done', '1');
  }

  function hydrateRecCard(el) {
    if (!el || el.getAttribute('data-platmart-done') === '1') return;
    var handle = el.getAttribute('data-product-handle');
    if (!handle) return;
    var member = lookupMember(handle);
    if (!member) {
      el.setAttribute('data-platmart-done', '1');
      return;
    }
    el.innerHTML = '';
    el.appendChild(buildSwatchDot(member, '0.625rem'));
    el.setAttribute('data-platmart-done', '1');
  }

  function hydrateAll(root) {
    var scope = root || document;
    var lines = scope.querySelectorAll('[data-platmart-cart-line]');
    lines.forEach(hydrateLineItem);
    var recs = scope.querySelectorAll('[data-platmart-cart-color]');
    recs.forEach(hydrateRecCard);
  }

  // ----- Carousel button visibility -----
  function updateCarouselButtons(scroll) {
    if (!scroll) return;
    var wrap = scroll.closest('.cart-recommendations__inner');
    if (!wrap) return;
    var prev = wrap.querySelector('.js-cart-rec-prev');
    var next = wrap.querySelector('.js-cart-rec-next');
    var sl = scroll.scrollLeft;
    var cw = scroll.clientWidth;
    var sw = scroll.scrollWidth;
    // If the drawer is hidden, measurements come back 0. Don't hide
    // the next button — leave it visible until we get real numbers.
    if (cw === 0 || sw === 0) {
      if (prev) prev.classList.add('is-hidden');
      if (next) next.classList.remove('is-hidden');
      return;
    }
    var max = sw - cw;
    // Prev: only show when scrolled past the start.
    if (prev) {
      if (sl > 4) prev.classList.remove('is-hidden');
      else prev.classList.add('is-hidden');
    }
    // Next: show by default. Only hide when we KNOW we're at the end
    // (sw is meaningfully larger than cw, and we've scrolled to the end).
    if (next) {
      if (sw > cw + 4 && sl >= max - 4) {
        next.classList.add('is-hidden');
      } else {
        next.classList.remove('is-hidden');
      }
    }
  }

  function bindCarousels(root) {
    var scope = root || document;
    var scrolls = scope.querySelectorAll('.js-cart-rec-scroll');
    scrolls.forEach(function (scroll) {
      if (scroll.dataset.recBound === '1') return;
      scroll.dataset.recBound = '1';
      // Initial state + on scroll
      updateCarouselButtons(scroll);
      scroll.addEventListener('scroll', function () {
        updateCarouselButtons(scroll);
      }, { passive: true });
      // Update on resize too (window resize changes clientWidth)
      window.addEventListener('resize', function () { updateCarouselButtons(scroll); });
    });
  }

  // Prev button click handler (next is already wired by
  // component-cart-recommendations.js).
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-cart-rec-prev');
    if (!btn) return;
    e.preventDefault();
    var inner = btn.closest('.cart-recommendations__inner');
    var scroll = inner && inner.querySelector('.js-cart-rec-scroll');
    if (scroll) scroll.scrollBy({ left: -scroll.clientWidth * 0.8, behavior: 'smooth' });
  });

  function init() {
    hydrateAll();
    bindCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-measure carousel buttons whenever the cart drawer becomes visible.
  // When the drawer is display:none, clientWidth/scrollWidth are 0 and the
  // initial measurement bails out (early return in updateCarouselButtons).
  // Once the drawer opens, sizes become real and we can correctly toggle
  // the next/prev visibility.
  function refreshAllCarousels() {
    document.querySelectorAll('.js-cart-rec-scroll').forEach(function (scroll) {
      updateCarouselButtons(scroll);
    });
  }
  function watchDrawerOpen() {
    var drawer = document.querySelector('w3-drawer-cart');
    if (!drawer) return;
    // Class-based: the theme toggles .drawer--visible on open.
    var mo = new MutationObserver(function () {
      if (drawer.classList.contains('drawer--visible')) {
        // Re-measure after the open animation paints.
        requestAnimationFrame(refreshAllCarousels);
        setTimeout(refreshAllCarousels, 100);
        setTimeout(refreshAllCarousels, 400);
      }
    });
    mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchDrawerOpen);
  } else {
    watchDrawerOpen();
  }
  // Also listen for the custom event other parts of the theme dispatch.
  document.addEventListener('theme:drawer:cart:open', function () {
    requestAnimationFrame(refreshAllCarousels);
    setTimeout(refreshAllCarousels, 100);
    setTimeout(refreshAllCarousels, 400);
  });

  // Re-hydrate when the cart drawer / recommendations re-render.
  document.addEventListener('cart-recommendations:update', function () {
    hydrateAll();
    bindCarousels();
    refreshAllCarousels();
  });

  // Watch the body for cart drawer updates (Shopify replaces the cart
  // sidebar on AJAX add/remove). When new line items or rec cards appear,
  // hydrate them.
  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches) {
            if (node.matches('[data-platmart-cart-line], [data-platmart-cart-color], .cart-recommendations__inner, .cart-products, w3-cart-items')) {
              hydrateAll(node.parentNode || node);
              bindCarousels(node.parentNode || node);
            }
          }
          if (node.querySelectorAll && node.querySelectorAll('[data-platmart-cart-line], [data-platmart-cart-color]').length) {
            hydrateAll(node);
            bindCarousels(node);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();
